import { Care, Delivery, SalesPerfomance, Tshirt } from '@srcDS/js/components/atoms/icons';

export const optionsActions = {
  theme: 'Sportscraft',
};


export const iconsAccordion = {
  productDetailsIcon: Tshirt,
  fabricAndCareIcon: Care,
  paymentOptionsIcon: SalesPerfomance,
  deliveryAndReturnsIcon: Delivery,
};
